import { plainToClass } from 'class-transformer'
import Response from '@/utils/response'
import Answer from '@/models/answer'
import Feeling from '@/models/feeling'
import pageLoading from '@/mixins/page-loading'
import pageTitle from '@/mixins/page-title'
import AnswerMemoField from '@/components/form/AnswerMemoField'
import DialogConfirm from '@/components/dialog/DialogConfirm'
import AnswerItemEditRow from '../AnswerItemEditRow/Bundle'

export default {
  components: {
    AnswerMemoField,
    DialogConfirm,
    AnswerItemEditRow
  },
  mixins: [
    pageLoading,
    pageTitle
  ],
  title () {
    return this.$t('pages.user.answers.edit.title')
  },
  props: {
    repository: Object,
    id: Number,
    error: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    processing: false,
    answer: new Answer,
    confirmDiscard: false,
  }),
  computed: {
    validates () {
      return Answer.validates
    },
    feeling () {
      return Feeling
    },
    backRoute () {
      return {
        name: 'answer-show',
        params: { id: this.answer.id },
      }
    },
    isDiscard () {
      if (this.answer.answer_items)
        return this.answer.answer_items.find(e => e._discard !== true) === undefined
      else
        return false
    },
  },
  watch: {
    answer () {
      this.$store.commit('setBackRoute', this.backRoute)
    },
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    onSave () {
      this.$validator.validate().then(result => {
        if (!result) return
        this.doUpdate()
      })
    },
    onCancel () {
      this.$router.push(this.backRoute)
    },

    async fetchData () {
      if (this.loading) return
      this.loading = true
      try {
        const response = new Response(await this.repository.edit(this.id))
        this.answer = plainToClass(Answer, response.result)
      } catch (error) {
        this.$store.commit('setAxiosError', error)
      } finally {
        this.loading = false
      }
    },
    async doUpdate () {
      if (this.processing) return
      this.processing = true
      try {
        const response = new Response(await this.repository.update(this.answer.id, {
          answer: this.answer.toParamsByUser
        }))
        this.$store.commit('setSnackbar', response.snackbarParams)
        if (response.meta.discarded)
          this.$router.push({ name: 'root' })
        else
          this.onCancel()
      } catch (error) {
        this.$store.commit('setAxiosError', error)
      } finally {
        this.processing = false
      }
    }
  }
}
